"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.InternalEvaluator = void 0;
const context_entries_1 = require("@comunica/context-entries");
const types_1 = require("@comunica/types");
const utils_algebra_1 = require("@comunica/utils-algebra");
const Eval = __importStar(require("@comunica/utils-expression-evaluator"));
const utils_query_operation_1 = require("@comunica/utils-query-operation");
const AlgebraTransformer_1 = require("./AlgebraTransformer");
/**
 * This class provides evaluation functionality to already transformed expressions.
 */
class InternalEvaluator {
    context;
    mediatorQueryOperation;
    bindingsFactory;
    transformer;
    subEvaluators = {
        [types_1.ExpressionType.Term]: (expr, _mapping) => this.term(expr),
        [types_1.ExpressionType.Variable]: (expr, mapping) => this.variable(expr, mapping),
        [types_1.ExpressionType.Operator]: (expr, mapping) => this.evalFunction(expr, mapping),
        [types_1.ExpressionType.Existence]: (expr, mapping) => this.evalExistence(expr, mapping),
        [types_1.ExpressionType.Aggregate]: (_expr, _mapping) => this.evalAggregate(),
    };
    constructor(context, mediatorFunctionFactory, mediatorQueryOperation, bindingsFactory) {
        this.context = context;
        this.mediatorQueryOperation = mediatorQueryOperation;
        this.bindingsFactory = bindingsFactory;
        this.transformer = new AlgebraTransformer_1.AlgebraTransformer(context, mediatorFunctionFactory);
    }
    async evaluatorExpressionEvaluation(expr, mapping) {
        const evaluator = this.subEvaluators[expr.expressionType];
        return evaluator.bind(this)(expr, mapping);
    }
    term(expr) {
        return expr;
    }
    variable(expr, mapping) {
        const term = mapping.get(Eval.expressionToVar(this.context.getSafe(context_entries_1.KeysInitQuery.dataFactory), expr));
        if (!term) {
            throw new Eval.UnboundVariableError(expr.name, mapping);
        }
        return this.transformer.transformRDFTermUnsafe(term);
    }
    async evalFunction(expr, mapping) {
        return expr.apply({
            args: expr.args,
            mapping,
            exprEval: this,
        });
    }
    async evalExistence(expr, mapping) {
        const dataFactory = this.context.getSafe(context_entries_1.KeysInitQuery.dataFactory);
        const algebraFactory = new utils_algebra_1.AlgebraFactory(dataFactory);
        const operation = (0, utils_query_operation_1.materializeOperation)(expr.expression.input, mapping, algebraFactory, this.bindingsFactory);
        const outputRaw = await this.mediatorQueryOperation.mediate({ operation, context: this.context });
        const output = (0, utils_query_operation_1.getSafeBindings)(outputRaw);
        return await new Promise((resolve, reject) => {
            output.bindingsStream.on('end', () => {
                resolve(false);
            });
            output.bindingsStream.on('error', reject);
            output.bindingsStream.on('data', () => {
                output.bindingsStream.close();
                resolve(true);
            });
        })
            .then((exists) => expr.expression.not ? !exists : exists)
            .then((exists) => new Eval.BooleanLiteral(exists));
    }
    evalAggregate() {
        throw new Eval.NoAggregator();
    }
}
exports.InternalEvaluator = InternalEvaluator;
//# sourceMappingURL=InternalEvaluator.js.map